import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaDirections,
} from "react-icons/fa";
import { LOCATION_LIST } from "../data/locations";

const quickLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about-us" },
  { label: "Menu", href: "/menu" },
  { label: "Cakes", href: "/cakes" },
  { label: "Gallery", href: "/gallery" },
  { label: "Contact Us", href: "/contact-us" },
];

const Footer = () => {
  return (
    <footer className="bg-ink text-gray-300">
      <div className="container mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand */}
        <div className="md:col-span-1">
          <img
            src="/images/secondhome_logo.png"
            alt="Second Home Kitchen & Restaurant"
            className="w-16 mb-4"
          />
          <h3 className="font-display text-white text-lg mb-2">
            Second Home Kitchen &amp; Restaurant
          </h3>
          <p className="text-sm text-gray-400 mb-4">
            Authentic Rajasthani &amp; Punjabi cuisine, served in a warm,
            traditional setting since 2017.
          </p>
          <div className="flex gap-3">
            <a
              href="https://www.facebook.com/thes.econdhome47"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary hover:text-ink transition-colors"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/second_home_mandsaur_/"
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-primary hover:text-ink transition-colors"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* Quick links */}
        <div>
          <h4 className="text-white font-semibold uppercase tracking-wide text-sm mb-4">
            Quick Links
          </h4>
          <ul className="space-y-2 text-sm">
            {quickLinks.map((link) => (
              <li key={link.href}>
                <Link to={link.href} className="hover:text-primary transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Locations */}
        <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-2 gap-6">
          {LOCATION_LIST.map((loc) => (
            <div key={loc.id}>
              <h4 className="text-white font-semibold uppercase tracking-wide text-sm mb-3">
                {loc.name} Branch
              </h4>
              <p className="text-sm flex gap-2 mb-3">
                <FaMapMarkerAlt className="text-primary mt-1 shrink-0" />
                <span>{loc.address}</span>
              </p>
              <a
                href={loc.phoneHref}
                className="text-sm flex items-center gap-2 mb-3 hover:text-primary transition-colors"
              >
                <FaPhoneAlt className="text-primary shrink-0" />
                {loc.phoneDisplay}
              </a>
              <a
                href={loc.directionsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm inline-flex items-center gap-2 text-primary hover:text-primary-light transition-colors"
              >
                <FaDirections />
                Get Directions
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="border-t border-white/10">
        <p className="text-gray-400 text-sm p-4 text-center">
          © 2026 Second Home Kitchen &amp; Restaurant. All Rights Reserved |{" "}
          <a href="/privacy-policy" className="text-primary hover:underline">
            Privacy &amp; Policy
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
